import { useAppStore } from '../../../../../store/appStore';
import { formatDate } from '../../../../../libs/dates';
import { stylesheet } from 'typestyle';
import { Blue80, Gray100, Tooltip, typeCompact14MediumProperties } from '@traceair/tds';
import { blueLinkStates } from '../../../../../styles/linkStates';
import { MouseEvent } from 'react';
import { ArrowForwardIcon } from '@traceair/webapp-icons';

const css = stylesheet({
  container: {
    display: 'inline-flex',
    columnGap: 3,
    marginTop: 16,
    flexWrap: 'wrap',
    ...typeCompact14MediumProperties,
  },
  containerInsideTooltip: {
    display: 'inline-flex',
    columnGap: 3,
    flexWrap: 'wrap',
  },
  initialDate: {
    color: Gray100,
  },
  changeIcon: {
    lineHeight: 0,
  },
  currentDate: {
    marginRight: 5,
  },
  reschedule: {
    color: Blue80,
    textDecoration: 'none',
    ...blueLinkStates,
  },
});

export const MissionWindowDate = () => {
  const { selectedMission, setSelectedDateChangeMission } = useAppStore();

  if (!selectedMission) return null;

  const { schedule, gcpPlacementService } = selectedMission;
  if (!schedule && !gcpPlacementService) return null;

  const handleReschedule = (e: MouseEvent) => {
    e.preventDefault();
    setSelectedDateChangeMission({ mission: selectedMission });
  };

  if (!schedule) {
    return (
      <div className={css.container}>
        <div className={css.currentDate}>{formatDate({ date: gcpPlacementService!.servicesPerformedDateIso })}</div>
      </div>
    );
  }

  return (
    <div className={css.container}>
      <Tooltip open={schedule.initialFlightDateIso ? undefined : false} description="The mission was rescheduled">
        <div className={css.containerInsideTooltip}>
          {!!schedule.initialFlightDateIso && schedule.initialFlightDateIso !== schedule.flightDateIso && (
            <>
              <div className={css.initialDate}>{formatDate({ date: schedule.initialFlightDateIso })}</div>
              <div className={css.changeIcon}>
                <ArrowForwardIcon size={16} color={Gray100} />
              </div>
            </>
          )}

          <div className={css.currentDate}>{formatDate({ date: schedule.flightDateIso })}</div>
        </div>
      </Tooltip>

      <div>
        <a href="#" className={css.reschedule} onClick={handleReschedule}>
          Reschedule
        </a>
      </div>
    </div>
  );
};
